import { render, staticRenderFns } from "./IntroManage.vue?vue&type=template&id=3e51f54e"
import script from "./IntroManage.vue?vue&type=script&lang=ts"
export * from "./IntroManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports